// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"c95d9b72","402":"cae6c50a","787":"db0f75ba"}[chunkId] + ".chunk.js";
};